import { ArrowPathIcon } from "@heroicons/react/24/outline";
import {
  Button,
  Checkbox,
  Container,
  Group,
  Paper,
  rem,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useState } from "react";
import { Breadcrumb } from "../../components/common/Breadcrumb";
import { IndexerService } from "../../services/indexerService";

export function OperationsData() {
  const [isIndexing, setIsIndexing] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [forceIndex, setForceIndex] = useState(false);

  const handleIndexCVs = async () => {
    setIsIndexing(true);
    setError(null);
    setSuccess(null);
    try {
      const indexerService = new IndexerService();
      const result = await indexerService.indexFiles(forceIndex);
      setSuccess(result.response);
    } catch (err) {
      console.error("Error indexing CVs:", err);
      setError(
        err instanceof Error
          ? err.message
          : "Failed to index CVs. Please try again."
      );
    } finally {
      setIsIndexing(false);
    }
  };

  return (
    <Container size="xl" py="xl">
      <Stack gap="xs" mb="xl">
        <Breadcrumb
          items={[
            { label: "Operations Panel", href: "/operations" },
            { label: "Data Management", isActive: true },
          ]}
        />
        <Title order={1} size="h2" fw={700}>
          Data Management
        </Title>
        <Text c="dimmed" size="lg">
          Manage CV indexing and data operations
        </Text>
      </Stack>

      <Paper p="md" withBorder>
        <Stack>
          <Title order={3} size="h4" fw={600}>
            CV Indexing
          </Title>
          <Text size="sm">
            Index all CVs in the system. This process may take some time
            depending on the number of CVs.
          </Text>
          <Group align="center">
            <Checkbox
              label="Force reindex"
              checked={forceIndex}
              onChange={(event) => setForceIndex(event.currentTarget.checked)}
              description="Force reindexing of all CVs, even if they haven't changed"
            />
          </Group>
          <Group>
            <Button
              size="lg"
              leftSection={
                <ArrowPathIcon style={{ width: rem(18), height: rem(18) }} />
              }
              onClick={handleIndexCVs}
              loading={isIndexing}
            >
              Index CVs
            </Button>
          </Group>
          {error && (
            <Text color="red" size="sm">
              {error}
            </Text>
          )}
          {success && (
            <Text color="green" size="sm">
              {success}
            </Text>
          )}
        </Stack>
      </Paper>
    </Container>
  );
}
